<template>
  <div>
    <template v-if="!multiMode">
      <div class="body-2">
        <template
          v-if="bundleDetail != null && bundleDetail.expireType == 'duration'"
        >
          <template v-if="bundleDetail.duration == 0">
            <span class="success--text font-weight-bold">
              Lifetime Access
            </span>
          </template>
          <template v-else>
            <span class="red--text text--darken-4 font-weight-bold">
              Expires in
              {{ durationExpires | moment("D MMMM YYYY HH:mm:ss") }}</span
            >
            <span class="text--secondary"> (estimate date)</span>
          </template>
        </template>
        <template
          v-else-if="
            bundleDetail != null && bundleDetail.expireType == 'expireDate'
          "
        >
          <span class="red--text text--darken-4 font-weight-bold">
            Expires in
            {{ bundleDetail.expireDate | moment("D MMMM YYYY HH:mm:ss") }}
          </span>
        </template>
        <template v-else>
          <div class="body-2">Choose package from below</div>
        </template>
      </div>
    </template>
    <template v-else> Not support yet </template>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  props: {
    multiMode: {
      type: Boolean,
      default: false,
    },
    bundle: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    expand: false,
  }),
  computed: {
    durationExpires() {
      if (this.bundleDetail != null && this.bundleDetail.duration != 0) {
        let expiresIn = Vue.moment().add(this.bundleDetail.duration, "days");
        return expiresIn.valueOf();
      }
      return 0;
    },
    bundleDetail() {
      if (this.bundle != null) {
        return this.bundle.items[0];
      }
      return null;
    },
  },
  watch: {
    bundle(val, old) {
      if (val != null) {
        this.expand = true;
      } else {
        this.expand = false;
      }
    },
  },
};
</script>